var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5.5,
    fill: "#242426",
    stroke: "#242426"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27394 9.45138H8.39941V9.34786C8.40535 8.75414 8.61321 8.47707 9.08241 8.18782C9.63771 7.84986 10 7.40228 10 6.68677C10 5.62112 9.16258 5 7.98367 5C6.90572 5 6.02673 5.5785 6 6.79638H7.21158C7.2294 6.30009 7.58872 6.0352 7.97773 6.0352C8.37862 6.0352 8.7023 6.30923 8.7023 6.73245C8.7023 7.1313 8.42019 7.39619 8.05494 7.63368C7.55605 7.95642 7.27691 8.28221 7.27394 9.34786V9.45138ZM7.85895 11.4C8.23905 11.4 8.56867 11.0742 8.57164 10.6693C8.56867 10.2704 8.23905 9.94462 7.85895 9.94462C7.46696 9.94462 7.14328 10.2704 7.14625 10.6693C7.14328 11.0742 7.46696 11.4 7.85895 11.4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.0f5ac5d1ce71d5d254a5e9fc4fe27c66.svg";
export { ForwardRef as ReactComponent };